import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostCreateLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_LOTTERY
            });
            dispatch(Action.SetGetListLottery({
                page: 1,
                rowsPerPage: 10
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateLottery as SetPostCreateLottery
}